import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import { CountryModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker/DatePicker";
import DynamicDropdown, { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextArea from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tSurya/Common/Utilities/validate";
import {
    FormErrorsStateType,
    intialErrorFormState,
    // OpenTradeValidatorConfig,
    ValidatorConfigType,
} from "@tSurya/Components/OpenTradeAccountValidatorConfig";
import { orderDetailsValidatorConfig } from "@tSurya/Components/orderDetailsValidatorConfig";
import Constant from "@tSurya/Constants/Constant";
import sendCustomConfig from "@tSurya/Handlers/SelectCustomConfigHandler";
import loadSaveAndContinue from "@tSurya/Handlers/SurOpenTradeAccountHandler";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import DataTable from "@tSurya/theme/styleguide/components/dataTable";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    saveAndContinueStep3?: any;
    previousStep3?: any;
    countries?: CountryModel[];
    placeOrder?: any;
    selectedShape?: string;
    feet?: number;
    inch?: number;
    roundfeet?: number;
    roundinch?: number;
    widthFeet?: number;
    widthInch?: number;
    lengthFeet?: number;
    lengthInches?: number;
    price?: string;
    product: ProductModel;
    currentShape?: string;
    closeHandler?: any;
}

const mapStateToProps = (state: CustomApplicationState) => ({
    openTradeAccountData: state.SURData.openTradeAccountStore,
    countries: getCurrentCountries(state),
    customData: getSession(state),
    userDetails: getBillToState(state, state.context.session.billToId).value,
    productPriceData: state.pages.productDetails.productInfosById,
    language: state.context.session.language,
});

const mapDispatchToProps = {
    loadCurrentCountries,
    sendCustomConfig,
};

export interface BillingInformationStyles {
    customerContainer?: InjectableCss;
    customerInfo?: InjectableCss;
    gridItem?: GridItemProps;
    customerInfoWrapper?: InjectableCss;
    accountNumber?: TextFieldProps;
    addressLineOne?: TypographyProps;
    poNumber?: InjectableCss;
    poNumberTextBox?: TextFieldProps;
    shipToNameTextBox?: TextFieldProps;
    shippingContainer?: InjectableCss;
    orderDetailsContainer?: InjectableCss;
    orderDetailsInnerContainer?: InjectableCss;
    orderDetailLabel?: InjectableCss;
    shippingLabel?: InjectableCss;
    billingLable?: InjectableCss;
    shippingField?: InjectableCss;
    customRequest?: InjectableCss;
    customRequestDropDown?: InjectableCss;
    policyContainer?: InjectableCss;
    policyheadinglabel?: InjectableCss;
    policySubheadinglabel?: InjectableCss;
    custContainer?: InjectableCss;
    custLabel?: InjectableCss;
    custField?: InjectableCss;
    custTextBox?: TextFieldProps;
    submitButton?: InjectableCss;
    buttonContainer?: InjectableCss;
    table?: InjectableCss;
    tableTextBox?: InjectableCss;
    requestContainer?: InjectableCss;
    requestLine?: InjectableCss;
    depositContainer?: InjectableCss;
    DatePickerContainer?: InjectableCss;
    DateLabel?: InjectableCss;
    DatePicker?: DatePickerPresentationProps;
    tableCells?: InjectableCss;
    tableContainer?: InjectableCss;
    listStyle?: DynamicDropdownPresentationProps;
    depositListStyle?: DynamicDropdownPresentationProps;
    dropdown?: InjectableCss;
    lableDivone?: InjectableCss;
    quantityLabel?: InjectableCss;
    lableDivtwo?: InjectableCss;
    textOne?: InjectableCss;
    emailText?: InjectableCss;
    termsAndConditionWrapper?: InjectableCss;
    termAndConditionHeading?: InjectableCss;
    termAndConditionContent?: InjectableCss;
    termsAndConditionNotes?: InjectableCss;
    textAreaEmail?: InjectableCss;
    container?: InjectableCss;
    signatureContainer?: InjectableCss;
    signatureTextField?: InjectableCss;
    orderDate?: InjectableCss;
    checkBoxContainer?: InjectableCss;
    checkboxData?: InjectableCss;
    checkboxText?: InjectableCss;
    informativeLine?: InjectableCss;
    informativeLineContainer?: InjectableCss;
    buttonWrapper?: InjectableCss;
    closeButton?: InjectableCss;
    sendOrder?: InjectableCss;
    sameBillingText?: InjectableCss;
    emailContainer?: InjectableCss;
    productTittle?: InjectableCss;
    rectangle?: InjectableCss;
    oval?: InjectableCss;
    square?: InjectableCss;
    round?: InjectableCss;
    octagon?: InjectableCss;
    shapesDetailsContainer?: InjectableCss;
    shapesDetailsWrapper?: InjectableCss;
    selectContainer?: InjectableCss;
    shapeDetailsInfoWrapper?: InjectableCss;
    shapeDetailsImageWrapper?: InjectableCss;
    shapeTitle?: TypographyProps;
    selectShapes?: SelectProps;
    currentShapesContainer?: InjectableCss;
    inputField?: GridItemProps;
    inputFieldContainer?: GridContainerProps;
    errorMsg?: TypographyProps;
    dimentionWrapper?: InjectableCss;
    note?: InjectableCss;
    customShapeLink?: LinkPresentationProps;
    shapeImageContainer?: LazyImageProps;
    width?: InjectableCss;
    length?: InjectableCss;
    Greeting?: InjectableCss;
    upperText?: InjectableCss;
    items?: GridItemProps;
    orderInfo?: TypographyProps;
    ctaLinks?: LinkPresentationProps;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const BillingInformationStyles: BillingInformationStyles = {
    gridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    shapeTitle: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.smaller};
        `,
    },
    shapeImageContainer: {
        css: css`
            margin: 0 auto;
            img {
                height: 250px;
            }
        `,
    },
    selectShapes: {
        css: css``,
    },
    inputField: {
        width: [12, 12, 6, 6, 6],
        css: css``,
    },
    inputFieldContainer: {
        css: css`
            width: 100%;
            margin-bottom: 20px;
        `,
    },
    selectContainer: {
        css: css`
            width: 100%;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
        `,
    },
    currentShapesContainer: {
        css: css`
            width: 100%;
        `,
    },
    customShapeLink: {
        css: css`
            span {
                color: ${COLORS.red} !important;
            }
        `,
    },
    errorMsg: {
        variant: "p",
        css: css`
            color: ${COLORS.red};
            margin: 3px 0;
        `,
    },
    customerInfo: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            //margin-top: 20px;
            input {
                width: 40%;
            }
        `,
    },
    customerInfoWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            column-gap: 30px;
            border: 1px solid ${getColor("common.border")};
            padding: 21px 32px 32px;
            width: 100%;
            height: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    accountNumber: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formInputWrapper: css`
                input {
                    height: 40px !important;
                    background: none !important;
                }
            `,
        },
    },
    addressLineOne: {
        css: css`
            margin-top: 10px;
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.larger};
            color: ${getColor("text.main")};
        `,
    },
    poNumber: {
        css: css`
            //margin-top: 30px;
            width: 32%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-top: 20px;
                    `,
                    css`
                        width: 100%;
                        margin-top: 20px;
                    `,
                    css`
                        width: 48%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    poNumberTextBox: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
                // margin-top: 10px;
            `,
            formField: css`
                display: flex;
                flex-wrap: wrap;
                margin-top: 28px;
                align-items: center;
                label {
                    width: 100%;
                    margin-bottom: 10px;
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 22px;
                    color: ${getColor("text.main")};
                }
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    height: 40px !important;
                }
            `,
        },
    },
    shippingContainer: {
        css: css`
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    shippingLabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
            display: flex;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    shippingField: {
        css: css`
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            padding: 20px;
            gap: 18px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        column-gap: 20px;
                    `,
                    css`
                        column-gap: 20px;
                    `,
                    null,
                ])}
        `,
    },
    shipToNameTextBox: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                margin-top: 14px;
                margin-top: 0px;
                width: 32%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                    font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold} !important;
                    font-size: ${TYPOGRAPHY.size.smaller} !important;
                    line-height: ${TYPOGRAPHY.lineHeight.base} !important;
                    color: ${getColor("text.main")} !important;
                    margin-bottom: 4px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 48%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    width: 100% !important;
                    max-width: 340px;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.base} !important;
                    font-size: ${TYPOGRAPHY.size.small} !important;
                    line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
                    color: ${getColor("text.accent")} !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    termsAndConditionWrapper: {
        css: css`
            margin-top: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    termAndConditionHeading: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    termAndConditionContent: {
        css: css`
            padding: 20px 32px;
            /* background: ${getColor("common.backgroundContrast")}; */
        `,
    },
    termsAndConditionNotes: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
            padding-bottom: 6px;
        `,
    },
    orderDetailsContainer: {
        css: css`
            /* margin-top: 20px; */
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    orderDetailsInnerContainer: {
        css: css`
            margin-top: 15px;
        `,
    },
    orderDetailLabel: {
        css: css`
            padding: 14px 20px 15px 20px;
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            > span {
                font-family: "Mulish";
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 26px;
                color: ${getColor("text.main")};
            }
            /* margin-bottom: 16px; */
        `,
    },
    customRequest: {
        css: css``,
    },
    customRequestDropDown: {
        css: css``,
    },
    policyContainer: {
        css: css`
            margin-top: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    policyheadinglabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    policySubheadinglabel: {
        css: css`
            padding: 0 20px 20px;
            display: block;
        `,
    },
    custContainer: {
        css: css`
            margin-top: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    custLabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    custField: {
        css: css`
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            padding: 0 20px 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    custTextBox: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                margin-top: 14px;
                /* margin-top: 0px; */
                width: 32%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 48%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    //height: 20px !important;
                    width: 100% !important;
                    max-width: 340px;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    submitButton: {
        css: css`
            padding: 10px;
            margin-top: 30px;
            min-height: 40px;
            width: 119px;
            border-radius: 0.5em;
        `,
    },
    buttonContainer: {
        css: css`
            margin-top: 20px;
        `,
    },
    table: {
        css: css`
            th,
            tr,
            td {
                border: none;
                height: none !important;
            }
            th {
                text-align: start !important;
                height: 16px !important;
            }
            tr {
                background-color: white !important;
                &:nth-child(even) {
                    background: white !important ;
                }
            }
            td {
                padding: 0px 2px !important;
                height: 5px;
                input {
                    height: 30px !important;
                }
            }
        `,
    },
    tableTextBox: {
        css: css`
            border-radius: 5px !important;
        `,
    },
    requestContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 20px 10px;
            margin-bottom: 10px;
        `,
    },
    requestLine: {
        css: css`
            margin-right: 20px;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            margin-bottom: 10px;
            line-height: 22px;
            color: ${getColor("text.main")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                    `,
                    css`
                        font-size: 14px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    depositContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            margin-bottom: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                        flex-direction: column;
                    `,
                    css`
                        flex-wrap: wrap;
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    DatePickerContainer: {
        css: css`
            display: block;
        `,
    },
    DateLabel: {
        css: css`
            margin-right: 164px;
            margin-top: 10px;
        `,
    },

    DatePicker: {
        cssOverrides: {
            formInputWrapper: css`
                align-items: center;
                margin-top: 5px;
                margin-right: 3px;
                display: flex;
                &::after {
                    content: "Now";
                    margin-left: 10px;
                }
            `,
        },
    },
    tableCells: {
        css: css``,
    },
    tableContainer: {
        css: css`
            padding: 0 20px 20px;
            display: block;
            table[class^="DataTableStyle"] {
                width: 100%;
            }
        `,
    },
    listStyle: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                /* margin-top: 14px; */
                width: 32%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                    font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold} !important;
                    font-size: ${TYPOGRAPHY.size.smaller} !important;
                    line-height: ${TYPOGRAPHY.lineHeight.base} !important;
                    color: ${getColor("text.main")} !important;
                    margin-bottom: 4px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 48%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    width: 100% !important;
                    max-width: 340px;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
                > div span[class^="IconWrapper"] {
                    /* right: 71px; */
                    right: 3px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                right: 5px;
                            `,
                            css`
                                right: 5px;
                            `,
                            css`
                                right: 10px;
                            `,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    depositListStyle: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                margin-top: 14px;
                width: 100%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 6px !important;
                input {
                    width: 100% !important;
                    max-width: 100% !important;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
                > div span[class^="IconWrapper"] {
                    right: 3px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                right: 5px;
                            `,
                            css`
                                right: 5px;
                            `,
                            css`
                                right: 10px;
                            `,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    lableDivone: {
        css: css`
            padding: 8px 20px 0;
        `,
    },
    quantityLabel: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base} !important;
            font-size: ${TYPOGRAPHY.size.small} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
            color: ${getColor("text.main")} !important;
            margin-right: 12px;
        `,
    },
    lableDivtwo: {
        css: css`
            padding: 10px;
            padding-left: 20px;
        `,
    },
    textOne: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base} !important;
            font-size: ${TYPOGRAPHY.size.small} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
            color: ${getColor("text.main")} !important;
        `,
    },
    emailText: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold} !important;
            font-size: ${TYPOGRAPHY.size.large} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
            color: ${getColor("text.main")} !important;
            &:last-of-type {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
                color: ${getColor("text.main")} !important;
            }
        `,
    },
    textAreaEmail: {
        css: css`
            resize: none;
        `,
    },
    container: {
        css: css`
            display: flex;
            padding: 20px;
            padding-top: 0;
            gap: 20px;
            > div > label {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base} !important;
                color: ${getColor("text.main")} !important;
            }
            > div > div > input {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
                color: ${getColor("text.accent")} !important;
            }
        `,
    },
    signatureTextField: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: ${TYPOGRAPHY.lineHeight.base} !important;
            color: ${getColor("text.main")} !important;
            > label {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base} !important;
                color: ${getColor("text.main")} !important;
            }
        `,
    },
    orderDate: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: ${TYPOGRAPHY.lineHeight.base} !important;
            color: ${getColor("text.main")} !important;
            > label {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base} !important;
                color: ${getColor("text.main")} !important;
            }
        `,
    },
    checkBoxContainer: {
        css: css`
            padding: 20px;
            padding-bottom: 0px;
        `,
    },
    checkboxData: {
        css: css`
            margin-right: 10px;
        `,
    },
    checkboxText: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            color: ${getColor("text.main")} !important;
        `,
    },
    informativeLine: {
        css: css`
            color: black;
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base} !important;
            font-size: ${TYPOGRAPHY.size.small} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
            color: ${getColor("text.accent")} !important;
        `,
    },
    informativeLineContainer: {
        css: css`
            padding: 20px;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #cccccc;
            padding: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        row-gap: 10px;
                    `,
                    css`
                        flex-direction: column;
                        row-gap: 10px;
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    sendOrder: {
        css: css`
            padding: 11px 34px;
            background: ${getColor("primary")};
            float: right;
            border-radius: 0px;
            > span {
                color: ${getColor("secondary.contrast")};
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
            }
        `,
    },
    closeButton: {
        css: css`
            border: 1px solid ${getColor("primary")};
            border-radius: 0px;
            background-color: ${getColor("secondary.contrast")};
            padding: 11px 34px;
            > span {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${getColor("text.main")};
            }
            &:hover {
                > span {
                    color: ${getColor("secondary.contrast")};
                }
            }
        `,
    },
    billingLable: {
        css: css`
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            > span {
                font-family: "Mulish";
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 26px;
                color: ${getColor("text.main")};
            }
            /* margin-bottom: 20px; */
        `,
    },
    sameBillingText: {
        css: css`
            margin-right: 20px;
        `,
    },
    upperText: {
        css: css`
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    emailContainer: {
        css: css`
            padding: 0 20px 8px;
        `,
    },
    productTittle: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: ${getColor("common.backgroundContrast")};
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    rectangle: {
        css: css`
            width: 150px;
            height: 300px;
            background: ${getColor("common.backgroundContrast")}; ;
        `,
    },
    octagon: {
        css: css`
            width: 400px;
            height: 400px;
            background: ${getColor("common.backgroundContrast")};
            position: relative;
            & *::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                border-bottom: 29px solid red;
                border-left: 29px solid #eee;
                border-right: 29px solid #eee;
                width: 42px;
                height: 0;
            }
            & *::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                border-top: 29px solid red;
                border-left: 29px solid #eee;
                border-right: 29px solid #eee;
                width: 42px;
                height: 0;
            }
        `,
    },
    round: {
        css: css`
            width: 500px;
            height: 500px;
            background: ${getColor("common.backgroundContrast")};
            -moz-border-radius: 50px;
            -webkit-border-radius: 50px;
            border-radius: 50px;
        `,
    },
    square: {
        css: css`
            width: 500px;
            height: 500px;
            background: ${getColor("common.backgroundContrast")}; ;
        `,
    },
    oval: {
        css: css`
            width: 200px;
            height: 500px;
            background: ${getColor("common.backgroundContrast")};
            -moz-border-radius: 100px / 50px;
            -webkit-border-radius: 100px / 50px;
            border-radius: 100px / 50px;
        `,
    },
    shapesDetailsContainer: {
        css: css`
            display: flex;
        `,
    },
    shapesDetailsWrapper: {
        css: css`
            display: flex;
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
            min-width: 100%;
            padding: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    css`
                        display: flex;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    Greeting: {
        css: css`
            font-size: 28px;
            font-weight: bold;
            text-transform: capitalize;
            margin-bottom: 10px;
        `,
    },
    shapeDetailsInfoWrapper: {
        css: css`
            width: 45%;
            max-width: 45%;
            min-width: 45%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        max-width: 100%;
                        min-width: 100%;
                    `,
                    css`
                        width: 100%;
                        max-width: 100%;
                        min-width: 100%;
                    `,
                    css`
                        width: 45%;
                        max-width: 45%;
                        min-width: 45%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    shapeDetailsImageWrapper: {
        css: css`
            width: 50%;
            max-width: 50%;
            min-width: 50%;
            display: flex;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        max-width: 100%;
                        min-width: 100%;
                        margin-top: 20px;
                    `,
                    css`
                        width: 100%;
                        max-width: 100%;
                        min-width: 100%;
                        margin-top: 20px;
                    `,
                    css`
                        width: 60%;
                        max-width: 60%;
                        min-width: 60%;
                    `,
                    null,
                    null,
                ])}
            > div > h2 {
                text-align: center;
            }
        `,
    },
    dimentionWrapper: {
        css: css`
            display: flex;
        `,
    },
    width: {
        css: css`
            display: flex;
        `,
    },
    length: {
        css: css`
            display: flex;
        `,
    },
    items: {
        width: [12, 12, 4, 4, 4],
        css: css`
            [class^="FormFieldStyle"] {
                width: 100%;
            }
        `,
    },
    orderInfo: {
        variant: "p",
        css: css`
            color: ${COLORS.red};
            margin-bottom: 0;
        `,
    },
    ctaLinks: {
        css: css`
            span {
                color: ${COLORS.red} !important;
                font-weight: ${TYPOGRAPHY.weight.bold};
            }
        `,
    },
    note: {
        css: css`
            font-weight: bold;
        `,
    },
    signatureContainer: {
        css: css`
            display: flex;
            padding: 20px;
            padding-top: 0;
            gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])};
            > div > label {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base} !important;
                color: ${getColor("text.main")} !important;
            }
            > div > div > input {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
                color: ${getColor("text.accent")} !important;
            }
        `,
    },
};

const styles = BillingInformationStyles;

const emailRequiredFieldMessage = siteMessage("Email is Required");
const emailFieldMessage = siteMessage("Invalid Email");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

export interface ShapesInterface {
    Rectangle: string;
    Round: string;
    Square: string;
    Oval: string;
    Octagon: string;
}

const shapesImage: ShapesInterface = {
    Rectangle: "staticContent/images/Rectangle.png",
    Round: "staticContent/images/Round.png",
    Square: "staticContent/images/Square.png",
    Oval: "staticContent/images/Oval.png",
    Octagon: "staticContent/images/Octagon.png",
};

const CustomRugQuoteForm = ({
    sendCustomConfig,
    customData,
    userDetails,
    loadCurrentCountries,
    countries,
    product,
    productPriceData,
    closeHandler,
    language,
}: Props) => {
    useEffect(() => {
        loadCurrentCountries();
    }, []);

    const [placeOrder, setPlaceOrder] = React.useState(false);
    const [shape, setShape] = React.useState(Object.values(shapesImage)[0]);
    const [currentShape, setCurrentShape] = React.useState(Object.keys(shapesImage)[0]);
    const accountNumberRequiredFieldMessage = siteMessage("Account number is Required");
    const depositMethodRequiredFieldMessage = siteMessage("Deposit Method is Required");
    const poNumberRequiredFieldMessage = siteMessage("PO number is Required");
    const sideMarkRequiredFieldMessage = siteMessage("Side Mark is Required");
    const quantityRequiredFieldMessage = siteMessage("Quantity is Required");
    const signatureFieldMessage = siteMessage("Signature is Required");
    const orderDateFieldMessage = siteMessage("Order Date is Required");
    const agreementRequiredMessage = siteMessage(
        "Agreement Box is required, please read the terms and conditions before request a quote",
    );
    const [timeOfDay, setTimeOfDay] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [accountNumber, setAccountNumber] = useState("");
    const [depositMethod, setDepositMethod] = useState("");
    const [poNumber, setPONumber] = useState("");
    const [poNumberError, setPONumberError] = useState("");
    const [quantity, setQuantity] = useState<any>("");
    const [quantityError, setQuantityError] = useState("");
    const [signature, setSignature] = useState("");
    const [signatureError, setSignatureError] = useState("");
    const [orderDate, setOrderDate] = useState<any>("");
    const [email, setEmail] = useState(customData.email);
    const [emailerror, setEmailError] = useState("");
    const [formErrorMessage, setFormErrorMessage] = useState(false);
    const [sidemark, setSidemark] = useState("");
    const [sidemarkError, setSidemarkError] = useState("");
    const [agreement, setAgreement] = useState(false);
    const [agreementError, setAgreementError] = useState("");
    const [comment, setComment] = useState("");
    const [incherror, setInchError] = useState("");

    // square
    const [feet, setFeet] = React.useState<any>("");
    const [inches, setInches] = React.useState<any>("");
    const [errorMessage, setErrorMessage] = React.useState<any>("");
    const toasterContext = useContext(ToasterContext);
    // reactangle
    const [widthFeet, setWidthFeet] = React.useState<any>("");
    const [widthInches, setWidthInches] = React.useState<any>("");
    const [lengthFeet, setLengthFeet] = React.useState<any>("");
    const [lengthInches, setLengthInches] = React.useState<any>("");
    const [error, setError] = React.useState("");

    // round
    const [roundfeet, setRoundFeet] = React.useState<any>("");
    const [roundinches, setRoundInches] = React.useState<any>("");
    const [roundErrorMessage, setRoundErrorMessage] = React.useState("");
    const [productDescription, setProductDescription] = React.useState("");

    // oval
    const [ovalWidthfeet, setWidthOvalFeet] = React.useState<any>("");
    const [ovalWidthinches, setOvalWidthInches] = React.useState<any>("");
    const [ovalHeightFeet, setOvalHeightFeet] = React.useState<any>("");
    const [ovalheightInches, setOvalHeightInches] = React.useState<any>("");
    const [ovalErrorMessage, setOvalErrorMessage] = React.useState("");

    // octagon
    const [octagonfeet, setOctagonFeet] = React.useState<any>("");
    const [octagoninches, setOctagonInches] = React.useState<any>("");
    const [octagonErrorMessage, setOctagonErrorMessage] = React.useState("");

    React.useEffect(() => {
        const date = getLocalizedDateTime({
            dateTime: new Date(),
            language,
            options: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            },
        });
        setOrderDate(date);
        setSignature(userDetails?.companyName || "");
        const currentDate = new Date(date);
        const currentHour = currentDate.getHours();
        let timeOfDay;
        if (currentHour < 12) {
            timeOfDay = "morning";
        } else if (currentHour >= 12 && currentHour < 17) {
            timeOfDay = "afternoon";
        } else {
            timeOfDay = "evening";
        }
        setTimeOfDay(timeOfDay);
    }, []);

    const clearFields = () => {
        setFeet("");
        setInches("");
        setErrorMessage("");
        setPlaceOrder(false);
        setInchError("");

        setWidthFeet("");
        setWidthInches("");
        setLengthFeet("");
        setLengthInches("");
        setError("");

        setRoundFeet("");
        setRoundInches("");
        setRoundErrorMessage("");

        setOvalWidthInches("");
        setWidthOvalFeet("");
        setOvalHeightFeet("");
        setOvalHeightInches("");
        setOvalErrorMessage("");

        setOctagonFeet("");
        setOctagonInches("");
        setOctagonErrorMessage("");
    };

    const calculateRectangleDimension = () => {
        if (widthFeet === 0 || lengthFeet === 0) {
            setError("Minimum value should be 1 ft");
            setPlaceOrder(false);
        } else {
            setPlaceOrder(true);
            setError("");
        }
    };

    const validateFeet = (feet: HTMLInputElement | number) => {
        const feetNum = parseInt(String(feet), 10);
        if (feetNum <= 0 || !feetNum) {
            return "Feet must be greater than 0";
        }

        return "";
    };

    const handleSquareDimension = () => {
        const feetError = validateFeet(feet);
        if (feetError) {
            setErrorMessage(`${feetError}`);
            setPlaceOrder(false);
        } else {
            setErrorMessage("");
            setPlaceOrder(true);
        }
    };

    const validateRoundFeet = (feet: HTMLInputElement | number) => {
        const feetNum = parseInt(String(feet), 10);
        if (feetNum <= 0 || !feetNum) {
            return "Feet must be greater than 0";
        }

        return "";
    };

    const handleRoundDimension = () => {
        const feetError = validateRoundFeet(roundfeet);
        if (feetError) {
            setRoundErrorMessage(`${feetError}`);
            setPlaceOrder(false);
        } else {
            setRoundErrorMessage("");
            setPlaceOrder(true);
        }
    };

    const calculateOvalDimension = () => {
        if (widthFeet === 0 || lengthFeet === 0) {
            setOvalErrorMessage("Minimum value should be 1 ft");
            setPlaceOrder(false);
        } else {
            setOvalErrorMessage("");
            setPlaceOrder(true);
        }
    };

    const validateOctagonFeet = (feet: HTMLInputElement | number) => {
        const feetNum = parseInt(String(feet), 10);
        if (feetNum <= 0 || !feetNum) {
            return "Feet must be greater than 0";
        }
        return "";
    };

    const handleOctagonDimension = () => {
        const feetError = validateOctagonFeet(roundfeet);
        if (feetError) {
            setOctagonErrorMessage(`${feetError}`);
            setPlaceOrder(false);
        } else {
            setOctagonErrorMessage("");
            setPlaceOrder(true);
        }
    };

    useEffect(() => {
        if (countries) {
            countries;
        }
    }, []);

    React.useEffect(() => {
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    }, [formErrors]);
    React.useEffect(() => {
        setFormErrorMessage(submitFormError());
    });

    const selectedCountry = countries?.find(c => c.abbreviation === "US");

    // const handlePrevious = () => {
    //     previousStep3();
    // };

    const submitFormError = () => {
        for (const key in formErrors) {
            if (formErrors[key] !== "") {
                return true;
            }
        }
        return false;
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    const requestOptions = [{ optionText: "Quote" }, { optionText: "Order" }];

    const [request, setRequest] = useState(requestOptions[0].optionText);

    const depoisteOptions = [
        { optionText: "Select an Option" },
        { optionText: "Credit Card" },
        { optionText: "Check" },
    ];
    const shapesOptions = [
        { optionText: "Check" },
        { optionText: "Rectangle" },
        { optionText: "Square" },
        { optionText: "Round" },
        { optionText: "Oval" },
        { optionText: "Octagon" },
    ];

    const resetForm = () => {
        setAccountNumber("");
    };

    const [deposit, setDeposit] = useState(depoisteOptions[0].optionText);
    const [shapes, setShapes] = useState(shapesOptions[0].optionText);

    const listsInputChangeHandler = (event: any) => {
        setDeposit(event);
    };
    const shapesInputChangeHandler = (event: any) => {
        setShapes(event);
    };

    // Account Number
    const accountNumberChangeHandler = (input: HTMLInputElement) => {
        setAccountNumber(input.value);
    };

    // Phone Number

    const validateSubmit = () => {
        const dimensionsAdded = Boolean((widthFeet && lengthFeet) || feet || roundfeet);
        return (
            !poNumber ||
            !sidemark ||
            !quantity ||
            !signature ||
            !email ||
            !agreement ||
            poNumberError ||
            sidemarkError ||
            quantityError ||
            emailerror ||
            signatureError ||
            agreementError ||
            incherror ||
            !dimensionsAdded
        );
    };

    const validatePONumber = (value: string) => {
        const errorMessage = !value ? poNumberRequiredFieldMessage : "";
        setPONumberError(`${errorMessage}`);
        return !errorMessage;
    };

    const poNumberChangeHandler = (value: string) => {
        validatePONumber(value);
        setPONumber(value);
    };

    const validateSideMark = (value: string) => {
        const errorMessage = !value ? sideMarkRequiredFieldMessage : "";
        setSidemarkError(`${errorMessage}`);
        return !errorMessage;
    };

    const sidemarkHandler = (value: string) => {
        validateSideMark(value);
        setSidemark(value);
    };

    // Signature

    const validateSignature = (value: string) => {
        const errorMessage = !value ? signatureFieldMessage : "";
        setSignatureError(`${errorMessage}`);
        return !errorMessage;
    };

    const signatureChangeHandler = (input: string) => {
        validateSignature(input);
        setSignature(input);
    };

    // Order Date
    const orderChangeHandler = (input: HTMLInputElement) => {
        setOrderDate(input.value);
    };

    // Quantity

    const validateQuantity = (value: string) => {
        const errorMessage = !value || value === "0" ? quantityRequiredFieldMessage : "";
        setQuantityError(`${errorMessage}`);
        return !errorMessage;
    };

    const quantityChangeHandler = (value: string) => {
        validateQuantity(value);
        setQuantity(value);
    };

    // Email

    const validateEmail = (email: string) => {
        // const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        const errorMessage = !email ? emailRequiredFieldMessage : "";
        setEmailError(`${errorMessage}`);
        return !errorMessage;
    };

    const emailChangeHandler = (value: string) => {
        validateEmail(value);
        setEmail(value);
    };
    const commentHandler = (e: any) => {
        setComment(e.target.value);
    };

    const handleSelectChange: SelectProps["onChange"] = event => {
        clearFields();
        setPlaceOrder(false);
        Object.entries(shapesImage).forEach(([key, value]) => {
            if (`${key}` === `${event.target.value}`) {
                setShape(value);
                setCurrentShape(key);
            }
        });
    };

    const handleAgreement = () => {
        if (agreement === false) {
            setAgreement(true);
            setAgreementError("");
        } else {
            setAgreementError(`${agreementRequiredMessage}`);
            setAgreement(false);
        }
    };

    const customConfigSender = () => {
        const customConfigParams: any = {
            ProductNumber: product?.productNumber,
            Shape: currentShape,
            WidthFeet: widthFeet === "" ? 0 : widthFeet,
            WidthInches: widthInches === "" ? 0 : widthInches,
            LengthFeet: lengthFeet === "" ? 0 : lengthFeet,
            LengthInches: lengthInches === "" ? 0 : lengthInches,
            SideFeet: feet === "" ? 0 : feet,
            Sideinches: inches === "" ? 0 : inches,
            DiameterFeet: roundfeet === "" ? 0 : roundfeet,
            DiameterInches: roundinches === "" ? 0 : roundinches,
            PoNumber: poNumber,
            Sidemark: sidemark,
            Quantity: quantity as unknown as number,
            Description: productDescription,
            Price: `${productPriceData && productPriceData[product.id]?.pricing?.actualPriceDisplay} psf for Standard`,
            CustomSize: `${
                product?.productNumber.toLowerCase().endsWith(Constant.customExpiditeProduct) ? "EXPEDITED" : "STANDARD"
            }`,
            LeadTime: `${
                product?.productNumber.toLowerCase().endsWith(Constant.customProduct) ? "3 - 4 Weeks" : "30 - 32 Weeks"
            }`,
            Comment: comment,
            Signature: userDetails?.companyName,
            QuoteDate: orderDate,
            EmailList: email,
            Subject: product?.productNumber.toLowerCase().endsWith(Constant.customProduct)
                ? "Custom Rug Pad"
                : "Custom Rug",
        };
        sendCustomConfig({
            ...customConfigParams,
            onComplete(result) {
                closeHandler();
                toasterContext.addToast({
                    body: translate(`Quote Submitted Successfully`),
                    messageType: "success",
                });
            },
        });
    };
    React.useEffect(() => {
        if (currentShape === "Rectangle") {
            setProductDescription(
                `${product?.productTitle}-${widthFeet}${widthInches}${lengthFeet}${lengthInches} (${
                    widthFeet && widthFeet > 0 && widthFeet
                }${widthInches && widthInches > 0 && `'${widthInches}`}" X ${
                    lengthFeet && lengthFeet > 0 && lengthFeet
                }${lengthInches && lengthInches > 0 && `'${lengthInches}`}"{" "}${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Square") {
            setProductDescription(
                `${product?.productTitle}-${feet}${inches}SQ (${feet && feet > 0 ? feet : 0}'${
                    inches && inches > 0 && inches
                }" ${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Round") {
            setProductDescription(
                `${product?.productTitle}-${roundfeet}${roundinches}RD (${
                    roundfeet && roundfeet > 0 && `${roundfeet}'`
                }${roundinches && roundinches > 0 && `${roundinches}"`} ${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Oval") {
            setProductDescription(
                `${product?.productTitle}-${widthFeet}${widthInches}${lengthFeet}${lengthInches}OV (${
                    widthFeet && widthFeet > 0 && `${widthFeet}'`
                }${widthInches && widthInches > 0 && `${widthInches}"`} X ${
                    lengthFeet && lengthFeet > 0 && `${lengthFeet}'`
                }${lengthInches && lengthInches > 0 && `${lengthInches}"`}{" "}${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Octagon") {
            setProductDescription(
                `${product?.productTitle}-${feet}${inches}OC (${feet && feet > 0 && `${feet}'`}${
                    inches && inches > 0 && `${inches}"`
                } ${currentShape.toUpperCase()})`,
            );
        }
    }, [widthFeet, widthInches, lengthFeet, lengthInches, roundinches, roundfeet, feet, inches]);
    const inchesValidation = (state: any, value: number) => {
        if (value > 11) {
            setInchError("Inches may not exceed 11");
            setPlaceOrder(false);
            return;
        }
        setInchError("");
        setPlaceOrder(true);
        state(value);
    };
    return (
        <>
            <StyledWrapper {...styles.shippingContainer}>
                <StyledWrapper {...styles.orderDetailsContainer}>
                    <StyledWrapper {...styles.upperText}>
                        <Typography {...styles.Greeting}>Good {timeOfDay},</Typography>

                        <Typography>Please fill in the following fields of the form:</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.orderDetailLabel}>
                        <Typography> Quote Details</Typography>
                    </StyledWrapper>

                    <StyledWrapper {...styles.orderDetailsInnerContainer}>
                        <StyledWrapper {...styles.customerInfo}>
                            <GridContainer {...styles.container}>
                                <GridItem {...styles.gridItem}>
                                    <StyledWrapper {...styles.selectContainer}>
                                        <Typography {...styles.shapeTitle} as="p">
                                            Shape:
                                        </Typography>
                                        <Select onChange={handleSelectChange} {...styles.selectShapes}>
                                            <option value="Rectangle">Rectangle</option>
                                            <option value="Square">Square</option>
                                            <option value="Round">Round</option>
                                            <option value="Oval">Oval</option>
                                            <option value="Octagon">Octagon</option>
                                        </Select>
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        {currentShape === "Rectangle" && (
                                            <StyledWrapper {...styles.currentShapesContainer}>
                                                <Typography {...styles.shapeTitle}>Width:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            value={widthFeet}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setWidthFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            value={widthInches}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            // onChange={e => setWidthInches(parseInt(e.target.value))}
                                                            onChange={e =>
                                                                inchesValidation(setWidthInches, Number(e.target.value))
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>

                                                <Typography {...styles.shapeTitle}>Length:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            value={lengthFeet}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setLengthFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            value={lengthInches}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            // onChange={e => setHeightInches(parseInt(e.target.value))}
                                                            onChange={e =>
                                                                inchesValidation(
                                                                    setLengthInches,
                                                                    Number(e.target.value),
                                                                )
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                                {/* <Button
                                                    {...styles.buttonContainer}
                                                    onClick={calculateRectangleDimension}
                                                >
                                                    Calculate
                                                </Button> */}
                                                {error && (
                                                    <Typography variant="p" {...styles.errorMsg}>
                                                        {error}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        )}
                                        {currentShape === "Square" && (
                                            <StyledWrapper {...styles.currentShapesContainer}>
                                                <Typography {...styles.shapeTitle}>Side:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            value={feet}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            value={inches}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            onChange={e =>
                                                                inchesValidation(setInches, Number(e.target.value))
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                                {errorMessage && (
                                                    <Typography variant="p" {...styles.errorMsg}>
                                                        {errorMessage}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        )}
                                        {currentShape === "Round" && (
                                            <StyledWrapper {...styles.currentShapesContainer}>
                                                <Typography {...styles.shapeTitle}>Diameter:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            min={0}
                                                            value={roundfeet}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setRoundFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            min={0}
                                                            value={roundinches}
                                                            // eslint-disable-next-line radix
                                                            onChange={e =>
                                                                inchesValidation(setRoundInches, Number(e.target.value))
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>

                                                {roundErrorMessage && (
                                                    <Typography variant="p" {...styles.errorMsg}>
                                                        {roundErrorMessage}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        )}
                                        {currentShape === "Oval" && (
                                            <StyledWrapper {...styles.currentShapesContainer}>
                                                <Typography {...styles.shapeTitle}>Width:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            value={widthFeet}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setWidthFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            min={0}
                                                            value={widthInches}
                                                            // eslint-disable-next-line radix
                                                            onChange={e =>
                                                                inchesValidation(setWidthInches, Number(e.target.value))
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>

                                                <Typography {...styles.shapeTitle}>Length:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            min={0}
                                                            value={lengthFeet}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setLengthFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            value={lengthInches}
                                                            min={0}
                                                            // eslint-disable-next-line radix
                                                            onChange={e =>
                                                                inchesValidation(
                                                                    setLengthInches,
                                                                    Number(e.target.value),
                                                                )
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>

                                                {ovalErrorMessage && (
                                                    <Typography variant="p" {...styles.errorMsg}>
                                                        {ovalErrorMessage}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        )}
                                        {currentShape === "Octagon" && (
                                            <StyledWrapper {...styles.currentShapesContainer}>
                                                <Typography {...styles.shapeTitle}>Side:</Typography>
                                                <GridContainer {...styles.inputFieldContainer}>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="ft"
                                                            value={feet}
                                                            // eslint-disable-next-line radix
                                                            onChange={e => setFeet(parseInt(e.target.value))}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.inputField}>
                                                        <TextField
                                                            type="number"
                                                            placeholder="in"
                                                            value={inches}
                                                            // eslint-disable-next-line radix
                                                            onChange={e =>
                                                                inchesValidation(setInches, Number(e.target.value))
                                                            }
                                                        />
                                                    </GridItem>
                                                </GridContainer>

                                                {octagonErrorMessage && (
                                                    <Typography variant="p" {...styles.errorMsg}>
                                                        {octagonErrorMessage}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        )}
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        {incherror && (
                                            <Typography variant="p" {...styles.errorMsg}>
                                                {incherror}
                                            </Typography>
                                        )}
                                    </StyledWrapper>
                                </GridItem>
                                <GridItem {...styles.gridItem}>
                                    <LazyImage src={shape} {...styles.shapeImageContainer}></LazyImage>
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    </StyledWrapper>

                    {/* shapes end */}

                    <StyledWrapper {...styles.shippingField}>
                        <GridContainer>
                            <GridItem {...styles.items}>
                                <TextField
                                    {...styles.shipToNameTextBox}
                                    label={translate("Account Number")}
                                    placeholder={translate("Account Number")}
                                    name="accountNumber"
                                    value={userDetails?.customerNumber}
                                    onChange={e => accountNumberChangeHandler(e.currentTarget)}
                                    error={!!formErrors.accountNumber && formErrors.accountNumber}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.accountNumber ? AlertTriangle : undefined,
                                    }}
                                    required
                                    disabled={Boolean(userDetails?.customerName)}
                                />
                            </GridItem>
                            <GridItem {...styles.items}>
                                <TextField
                                    {...styles.shipToNameTextBox}
                                    label={translate("PO Number")}
                                    name="poNumber"
                                    type="text"
                                    min={0}
                                    maxLength={30}
                                    value={poNumber}
                                    required
                                    onChange={e => poNumberChangeHandler(e.target.value)}
                                    error={poNumberError}
                                    placeholder={translate("PO Number")}
                                    iconProps={{
                                        color: "danger",
                                        src: poNumberError ? AlertTriangle : undefined,
                                    }}
                                />
                            </GridItem>
                            <GridItem {...styles.items}>
                                <TextField
                                    {...styles.shipToNameTextBox}
                                    label={translate("QTY")}
                                    name="quantity"
                                    value={quantity}
                                    type="number"
                                    required
                                    min={0}
                                    // data-test-selector="createAccount_firstName"
                                    onChange={e => quantityChangeHandler(e.target.value)}
                                    error={quantityError}
                                    iconProps={{
                                        color: "danger",
                                        src: quantityError ? AlertTriangle : undefined,
                                    }}
                                    placeholder={translate("QTY")}
                                />
                            </GridItem>
                            <GridItem {...styles.items}>
                                <TextField
                                    {...styles.shipToNameTextBox}
                                    label={translate("SideMark")}
                                    placeholder={translate("SideMark")}
                                    value={sidemark}
                                    required
                                    onChange={e => sidemarkHandler(e.target.value)}
                                    error={sidemarkError}
                                    iconProps={{
                                        color: "danger",
                                        src: sidemarkError ? AlertTriangle : undefined,
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper>
                    <StyledWrapper {...styles.lableDivone}>
                        <Typography {...styles.quantityLabel}>
                            {currentShape === "Rectangle" && (
                                <Typography {...styles.orderInfo}>
                                    {product?.productTitle}-{widthFeet}
                                    {widthInches}
                                    {lengthFeet}
                                    {lengthInches} ({widthFeet && widthFeet > 0 && widthFeet}
                                    {widthInches && widthInches > 0 && `'${widthInches}`}" X{" "}
                                    {lengthFeet && lengthFeet > 0 && lengthFeet}
                                    {lengthInches && lengthInches > 0 && `'${lengthInches}`}"{" "}
                                    {currentShape.toUpperCase()})
                                </Typography>
                            )}
                            {currentShape === "Square" && (
                                <Typography {...styles.orderInfo}>
                                    {product?.productTitle}-{feet}
                                    {inches}SQ ({feet && feet > 0 ? feet : 0}'{inches && inches > 0 && inches}"
                                    {currentShape.toUpperCase()})
                                </Typography>
                            )}
                            {currentShape === "Round" && (
                                <Typography {...styles.orderInfo}>
                                    {product?.productTitle}-{roundfeet}
                                    {roundinches}RD ({roundfeet && roundfeet > 0 && `${roundfeet}'`}
                                    {roundinches && roundinches > 0 && `${roundinches}"`} {currentShape.toUpperCase()})
                                </Typography>
                            )}
                            {currentShape === "Oval" && (
                                <Typography {...styles.orderInfo}>
                                    {product?.productTitle}-{widthFeet}
                                    {widthInches}
                                    {lengthFeet}
                                    {lengthInches}OV ({widthFeet && widthFeet > 0 && `${widthFeet}'`}
                                    {widthInches && widthInches > 0 && `${widthInches}"`} X{" "}
                                    {lengthFeet && lengthFeet > 0 && `${lengthFeet}'`}
                                    {lengthInches && lengthInches > 0 && `${lengthInches}"`}{" "}
                                    {currentShape.toUpperCase()})
                                </Typography>
                            )}
                            {currentShape === "Octagon" && (
                                <Typography {...styles.orderInfo}>
                                    {product?.productTitle}-{feet}
                                    {inches}OC ({feet && feet > 0 && `${feet}'`}
                                    {inches && inches > 0 && `${inches}"`} {currentShape.toUpperCase()})
                                </Typography>
                            )}
                            <Typography {...styles.orderInfo}>
                                {productPriceData && productPriceData[product.id]?.pricing?.actualPriceDisplay} psf for{" "}
                                {product.productNumber.toLowerCase().endsWith("-cstd") ? "STANDARD" : "EXPEDITED"} (
                                {productPriceData &&
                                    productPriceData[product.id]?.pricing?.additionalResults?.customLeadtime}
                                )
                            </Typography>
                        </Typography>
                    </StyledWrapper>

                    <StyledWrapper>
                        <StyledWrapper {...styles.emailContainer}>
                            <Typography {...styles.shapeTitle}>Send this order to following emails:</Typography>
                            <Typography>Please add semicolon(;) to the end of each email</Typography>
                            <StyledWrapper>
                                <TextField
                                    {...styles.emailText}
                                    name="email"
                                    value={email}
                                    // data-test-selector="createAccount_firstName"
                                    onChange={e => emailChangeHandler(e.target.value)}
                                    error={emailerror}
                                    iconProps={{
                                        color: "danger",
                                        src: emailerror ? AlertTriangle : undefined,
                                    }}
                                    onBlur={e => emailChangeHandler(e.target.value)}
                                    placeholder={translate("Email Address")}
                                    autoComplete="off"
                                />
                            </StyledWrapper>
                            <StyledWrapper>
                                <TextArea
                                    placeholder={translate("Comment")}
                                    value={comment}
                                    onChange={e => commentHandler(e)}
                                    {...styles.textAreaEmail}
                                ></TextArea>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...styles.signatureContainer}>
                        <TextField
                            {...styles.signatureTextField}
                            label={translate("Signature")}
                            name="signature"
                            value={signature}
                            // data-test-selector="createAccount_phoneNumber"
                            onChange={e => signatureChangeHandler(e.target.value)}
                            error={signatureError}
                            iconProps={{
                                color: "danger",
                                src: signatureError ? AlertTriangle : undefined,
                            }}
                            placeholder={translate("Signature")}
                        ></TextField>
                        <TextField
                            {...styles.orderDate}
                            label={translate("Quote Date")}
                            name="orderDate"
                            value={orderDate}
                            disabled={Boolean(orderDate)}
                            placeholder={translate("Quote Date")}
                        ></TextField>
                    </StyledWrapper>
                    {/* Terms and conditions start */}

                    <StyledWrapper {...styles.termsAndConditionWrapper}>
                        <StyledWrapper {...styles.termAndConditionHeading}>
                            <Typography> Terms and Conditions </Typography>
                        </StyledWrapper>

                        {product?.properties?.productType === Constant.customProductType ? (
                            <StyledWrapper {...styles.termAndConditionContent}>
                                <Typography {...styles.termsAndConditionNotes} as="p">
                                    Please Note : Our custom order terms have changed,
                                </Typography>

                                <Typography {...styles.termsAndConditionNotes} as="p">
                                    {Constant.customRugPadTermsHeading}
                                </Typography>

                                <Typography as="p" {...styles.addressLineOne}>
                                    {siteMessage("TermsAndConditionCustomRugPad")}
                                </Typography>
                            </StyledWrapper>
                        ) : (
                            <StyledWrapper {...styles.termAndConditionContent}>
                                <Typography {...styles.termsAndConditionNotes} as="p">
                                    ***Minimum custom order: $500.00***
                                    <br />
                                    Please Note : Our custom order terms have changed,
                                    <br />
                                    {Constant.customRugTermsHeading}
                                </Typography>
                                <Typography as="p" {...styles.addressLineOne}>
                                    {siteMessage("TermsAndConditions")}
                                </Typography>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>

                    {/* Terms and conditions end */}
                    <StyledWrapper {...styles.checkBoxContainer}>
                        <Checkbox
                            {...styles.checkboxData}
                            checked={agreement}
                            onChange={e => handleAgreement()}
                        ></Checkbox>
                        <Typography {...styles.checkboxText}>{Constant.termsAndCondition}</Typography>
                        {agreementError && <Typography {...styles.errorMsg}>{agreementError}</Typography>}
                    </StyledWrapper>
                    <StyledWrapper {...styles.informativeLineContainer}>
                        <Typography {...styles.informativeLine}>
                            Please let us know if I can be of further assistance, you can email us to{" "}
                            <Link {...styles.ctaLinks} href="mailto:custom@surya.com">
                                custom@surya.com
                            </Link>{" "}
                            or by Phone:{" "}
                            <Link {...styles.ctaLinks} href="tel:8772757847">
                                877-275-7847
                            </Link>
                            .
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Button {...styles.closeButton} onClick={closeHandler}>
                            Close
                        </Button>
                        <Button {...styles.sendOrder} onClick={customConfigSender} disabled={Boolean(validateSubmit())}>
                            Request Quote
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomRugQuoteForm);
